import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import RichText, { domToReact } from '@/components/RichText/RichText';
import StrapiImage from '@/components/StrapiImage/StrapiImage';
import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';

import PersonInfo from './PersonInfo';
import {
  BigImage,
  Quote,
  TextContentWrapper,
  TextWrapper,
  TileText,
  VideoWrapper,
  Wrapper,
} from './VideoTile.style';

const getEmbedCode = url => (url ? url.match(/(=)(.+)/)[2] : '');

const richTextReplacer = (element, wrappedReplacer) => {
  if (element.name === 'p' && element.children.length) {
    return (
      <TileText variant="body1">
        {domToReact(element.children, { replace: wrappedReplacer })}
      </TileText>
    );
  }

  return null;
};

const VideoTile = ({
  content,
  logo,
  personName,
  companyName,
  video,
  bigImage,
}) => {
  const mobileMediaQuery = useMobileMediaQuery();

  return (
    <Wrapper
      data-test-subject="video-testimonial-tile"
      container
      flexWrap={mobileMediaQuery ? 'wrap-reverse' : 'wrap'}>
      <Grid item xs={12} md={6}>
        <TextContentWrapper direction="column">
          <TextWrapper>
            <Quote />
            <RichText data={content} replace={richTextReplacer} />
          </TextWrapper>
          <PersonInfo {...{ logo, personName, companyName }} />
        </TextContentWrapper>
      </Grid>
      <Grid item xs={12} md={6} pb={6.5}>
        {video ? (
          <VideoWrapper>
            <iframe
              title="videoTestimonial"
              src={`https://www.youtube.com/embed/${getEmbedCode(video)}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </VideoWrapper>
        ) : (
          <BigImage>
            <StrapiImage data={bigImage} />
          </BigImage>
        )}
      </Grid>
    </Wrapper>
  );
};

VideoTile.propTypes = {
  content: PropTypes.string.isRequired,
  /** Company logo. */
  logo: PropTypes.object,
  /** Company logo alt. */
  personName: PropTypes.string,
  /** Person role in company */
  companyName: PropTypes.string.isRequired,
  /** Testimonial Video */
  video: PropTypes.string,
  /** Testimonial big image */
  bigImage: PropTypes.object,
};

VideoTile.defaultProps = {
  logo: '',
  personName: '',
  video: '',
  bigImage: {},
};

export default VideoTile;
